import * as iotServicesSdk from 'iot-services-sdk';

const state = {    
    deviceProfiles:[],
    dataConverters: [],
    deviceProfileManager: null
}

const getters = {
        
}

const actions = {
    init({rootState, commit}){
        const httpInfo = rootState.metadata.backendApi.http.prod;
        
        const baseUrl = "https://" + httpInfo.host + "/" + httpInfo.basePath;
        const service = httpInfo.service;
        const region = httpInfo.region;

        const atrDeviceProfileManager = new iotServicesSdk.deviceprofile.assettracking.ATRDeviceProfileManager(
            new URL(baseUrl), 
            new iotServicesSdk.shared.auth.sigv4.SigV4Authorizer(service, region),
            region
        );

        const atrDataConverterManager = new iotServicesSdk.dataconverter.assettracking.ATRDataConverterManager(
            new URL(baseUrl), 
            new iotServicesSdk.shared.auth.sigv4.SigV4Authorizer(service, region),
            region
        );

        commit('init', {atrDeviceProfileManager, atrDataConverterManager})
    },

    deinit({commit}){
        return new Promise(
            (resolve)=>{
                commit('clearDeviceProfiles')
                commit('clearDataConverters')
                resolve()
            }
        )
    },


    fetchDataConverters:function({rootState, commit}){
        return new Promise(
            function(resolve,reject){
                commit('startOperation','Fetching data converters',{root:true})

                state.dataConverterManager.getDataConverters(rootState.authentication.credentials)
                //rootState.serviceModule.deviceManager.ListDataConverters()
                    .then((dataConverters)=>{           
                        commit('stopOperation',null,{root:true})
                        commit('successLastOperationPerformed','Data converters fetched',{root:true})
                        commit('updateDataConverters',dataConverters)
                        resolve()                        
                    })
                    .catch((err)=>{
                        commit('stopOperation',null,{root:true})
                        commit('errorLastOperationPerformed','Fetching data converters failed',{root:true})
                        reject(err)                
                    })
            }
        ) 
    },

    fetchDeviceProfiles({commit,rootState,state}){
        return new Promise(
            function(resolve,reject){
                commit('startOperation','Fetching device profiles',{root:true})
                
                state.deviceProfileManager.getDeviceProfiles(rootState.authentication.credentials)
                // rootState.serviceModule.deviceManager.ListDeviceProfiles()
                    .then((deviceProfiles)=>{         
                        commit('stopOperation',null,{root:true})
                        commit('successLastOperationPerformed','Device profiles fetched',{root:true})
                        commit('updateDeviceProfiles',deviceProfiles)
                        resolve()                        
                    })
                    .catch((err)=>{
                        commit('stopOperation',null,{root:true})
                        commit('errorLastOperationPerformed','Fetching device profiles failed',{root:true})
                        reject(err)                
                    })
            }
        ) 
    },

    createDeviceProfile({commit,rootState},deviceProfileModel){
        return new Promise(
            function(resolve,reject){
                commit('startOperation','Creating deviceProfile',{root:true})

                let newDeviceProfile = null;
                if(deviceProfileModel.technology == iotServicesSdk.shared.types.DeviceConnectivity.LORA_TTN) {
                    const newDeviceProfileContext = new iotServicesSdk.deviceprofile.assettracking.ATRLoraTTNProfileContext(
                        deviceProfileModel.region,
                        deviceProfileModel.application_id,
                        deviceProfileModel.application_eui,
                        deviceProfileModel.application_key,
                        deviceProfileModel.network_key,
                        deviceProfileModel.apikey,/*"NNSXS.GI5ZKPKYCQCYPWB5BF474MINQWIF7EK35YIUXYQ.AENMTW26VWV5GYMPEYEZUVG7264FHDV2AHLLFT5CCZHM6I2O46VQ"*/
                        deviceProfileModel.dsh_api_key /*|| "5890b43e-d7cc-472f-afc9-6d04d1fdb917.b6eaf21b-f60e-49d6-8de3-9d7c02dcfdd5"*/
                    );
                    newDeviceProfile = new iotServicesSdk.deviceprofile.assettracking.ATRNewDeviceProfileLorattn(
                        deviceProfileModel.id,
                        deviceProfileModel.label || deviceProfileModel.id,
                        deviceProfileModel.converter,
                        newDeviceProfileContext
                    );
                } else if(deviceProfileModel.technology === iotServicesSdk.shared.types.DeviceConnectivity.LORA_LORIOT) {
                    newDeviceProfile = new iotServicesSdk.deviceprofile.assettracking.ATRNewDeviceProfileLoraloriot(
                        deviceProfileModel.id,
                        deviceProfileModel.label || deviceProfileModel.id,
                        deviceProfileModel.converter
                    );
                } else if(deviceProfileModel.technology === iotServicesSdk.shared.types.DeviceConnectivity.LORA_MACHINEQ) {
                    newDeviceProfile = new iotServicesSdk.deviceprofile.assettracking.ATRNewDeviceProfileLoramachineq(
                        deviceProfileModel.id,
                        deviceProfileModel.label || deviceProfileModel.id,
                        deviceProfileModel.converter
                    );
                } else if(deviceProfileModel.technology === iotServicesSdk.shared.types.DeviceConnectivity.LORA_ACTILITY ) {
                    newDeviceProfile = new iotServicesSdk.deviceprofile.assettracking.ATRNewDeviceProfileLoraactility(
                        deviceProfileModel.id,
                        deviceProfileModel.label || deviceProfileModel.id,
                        deviceProfileModel.converter
                    );
                } else {
                    const newDeviceProfileContext = new iotServicesSdk.deviceprofile.assettracking.ATRSigfoxProfileContext(
                        deviceProfileModel.access_key,
                        deviceProfileModel.secret
                    );
                    newDeviceProfile = new iotServicesSdk.deviceprofile.assettracking.ATRNewDeviceProfileSigfox(
                        deviceProfileModel.id,
                        deviceProfileModel.label || deviceProfileModel.id,
                        deviceProfileModel.converter,
                        newDeviceProfileContext
                    );
                }

                state.deviceProfileManager.createDeviceProfile(newDeviceProfile, rootState.authentication.credentials)
                // rootState.serviceModule.deviceManager.CreateDeviceProfile(deviceProfileModel)
                    .then((data)=>{           
                        commit('stopOperation',null,{root:true})
                        commit('successLastOperationPerformed','Creating success',{root:true})
                        resolve(data)        
                    })
                    .catch((err)=>{
                        commit('stopOperation',null,{root:true})
                        commit('errorLastOperationPerformed','Creating failed'+((err)?': '+err:''),{root:true})
                        reject(err)          
                    })
            }
        )        
    },

    deleteDeviceProfile({commit,rootState},deviceProfile){
        return new Promise(
            function(resolve,reject){
                commit('startOperation','Deleting API key',{root:true})
                
                state.deviceProfileManager.deleteDeviceProfile(deviceProfile.id, rootState.authentication.credentials)
                    .then((data)=>{           
                        commit('stopOperation',null,{root:true})
                        commit('successLastOperationPerformed','Deleting success',{root:true})

                        commit('clearDeviceProfiles',deviceProfile)
                        resolve(data)                        
                    })
                    .catch((err)=>{
                        commit('stopOperation',null,{root:true})
                        commit('errorLastOperationPerformed','Deleting failed'+((err)?': '+err:''),{root:true})
                        reject(err)                
                    })
            }
        )        
    },
}

const mutations = {
    init(state, args) {
        state.deviceProfileManager = args.atrDeviceProfileManager;
        state.dataConverterManager = args.atrDataConverterManager;
    },

    clearDeviceProfiles(state, deviceProfile){
        if(deviceProfile)
            state.deviceProfiles = state
                            .deviceProfiles
                            .filter(
                                (storedDeviceProfile) => 
                                    !(deviceProfile.id==storedDeviceProfile.id)
                            )
        else
            state.devices.splice(0)
    },

    clearDataConverters(state, dataConverter){
        if(dataConverter)
            state.deviceProfiles = state
                            .dataConverters
                            .filter(
                                (storedDataConverter) => 
                                    !(dataConverter.id==storedDataConverter.id)
                            )
        else
            state.devices.splice(0)
    },

    updateDeviceProfiles(state,deviceProfiles){
        state.deviceProfiles = deviceProfiles
    },

    updateDataConverters(state,dataConverters){
        state.dataConverters = dataConverters
    }
}
  

export default{
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations,
    namespaced:true
}